// Utilities
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";

// Services
import { dashboardService } from "../../../../Api/Services/DashboardService";

// Types
import { IDashboardDetailsServiceResponse } from "../../types";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";

/**
 * Async thunk to fetch dashboard details.
 * Dispatches an API call to retrieve the dashboard data.
 */
export const fetchEmployeesDashboardDetailsThunk = createServiceAsyncThunk<
  IDashboardDetailsServiceResponse, // Response Type
  { activeYear: number } // Payload Type
>(
  ACTION_NAMES.FETCH_EMPLOYEE_DASHBOARD_DETAILS, // Name of the action
  ({ activeYear }) => dashboardService.getDashboardDetails(activeYear), // API call
  ERROR_MESSAGES.EMPLOYEE_DASHBOARD_FETCH_FAILURE // Error message
);

/**
 * Slice to manage the state of dashboard details.
 * Includes actions to clear errors and handle async states.
 */
const employeesDashboardDetailsSlice = createGenericSlice<
  IDashboardDetailsServiceResponse,
  { activeYear: number }
>(
  SLICE_NAMES.EMPLOYEE_DASHBOARD_DETAILS, // Slice Name
  fetchEmployeesDashboardDetailsThunk // Async Thunk
);

// Export actions for dispatching
export const { clearError: clearEmployeeDashboardErrors } =
  employeesDashboardDetailsSlice.actions;

// Export the reducer for integration in the Redux store
export default employeesDashboardDetailsSlice.reducer;
